import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import State from './State'
import Actions from './Actions'
import Mutations from './Mutations'

export default new Vuex.Store({

  // this trick allows us to reset the state after logout
  // with mutation STORE_DEFAULT_STATE_RESET
  state: JSON.parse(JSON.stringify(State)),

  actions: Actions,

  mutations: Mutations,

})
